import React, { useState, useCallback, useRef, useEffect} from 'react';
import SVPButton from 'src/components/SVPButtons/SVPButton';
import { strings } from 'src/localization';
import { Dialog } from '@framework-controls/core';
import css from './DesktopDiagnose.module.scss';
// import { diagnoseResponses, diagnoseLiterals } from '../DiagnoseTree/DiagnoseTree';
import { diagnoseResponses } from '../DiagnoseTreeLit/DiagnoseTreeLit';
import { IndexMapInterface } from '../WriteYourOwn';
import DesktopDiagnoseModal from './DesktopDiagnoseModal/DesktopDiagnoseModal';
import { IconRemove } from 'src/content/icons';
import classNames from 'classnames';
import { VehicleRec, ascCtaInteractionInput, ascElementConfigurationInput, ascPageviewInput } from 'src/models';
import { ascCtaInteraction, ascElementConfiguration, ascPageview, getElementColor } from 'src/helpers/EventHelper/EventHelper';

export interface IProps {
    // Adds the selected diagnosis to the list
    addDiagnosis: (title: string, additionalComments: string) => void;
    // A map of the currently selected dialog tree path
    indexMap: IndexMapInterface[];
    vehicles: VehicleRec[];
    selectedVehicle?: string;
    // Handles selection of the next option
    selectButton: (value: string) => void;
    nextButton: (selectedButton: string) => void;
    backButton: () => void;
    clearIndexMap: () => void;
    title?: string;
    theme: string,
}

const Diagnose = (props: IProps) => {
    const [additionalComments, setAdditionalComments] = useState('');
    const [selectedButton, setSelectedButton] = useState('');
    const [dialogActive, setDialogActive] = useState(false);
    const [error, setError] = useState(true);
    const commentRef = useRef(additionalComments);

    const diagnoseModalViews: any = useRef([]);
    const diagnoseLiterals = [
        {
            option: '',
            title: strings.WhichApplies,
            responses: [
                {
                    option: strings.IFeelIt,
                    underlined: strings.Feel,
                    title: strings.IFeel,
                    responses: [
                        {
                            option: strings.VehicleDrift,
                            title: strings.VehicleDriftTo,
                            responses: [
                                {
                                    option: strings.Left,
                                    title: strings.VehicleDriftToLeft,
                                    responses: [],
                                },
                                {
                                    option: strings.Right,
                                    title: strings.VehicleDriftToRight,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.PlaySteeringWheel,
                            title: strings.FeelPlaySteeringWheel,
                            responses: [],
                        },
                        {
                            option: strings.PulsingVibrations,
                            title: strings.FeelPulsingVibrations,
                            responses: [
                                {
                                    option: strings.FrontVehicle,
                                    title: strings.PulsingVibrationsFront,
                                    responses: [
                                        {
                                            option: strings.WhenAccelerating,
                                            title: strings.PulsingVibrationsFrontAccelerating,
                                            responses: [],
                                        },
                                        {
                                            option: strings.WhenBraking,
                                            title: strings.PulsingVibrationsFrontBraking,
                                            responses: [],
                                        },
                                        {
                                            option: strings.HigherSpeeds,
                                            title: strings.PulsingVibrationsFrontHigh,
                                            responses: [],
                                        },
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.PulsingVibrationsFrontAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.PulsingVibrationsFrontNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.RearVehicle,
                                    title: strings.PulsingVibrationsRear,
                                    responses: [
                                        {
                                            option: strings.WhenAccelerating,
                                            title: strings.PulsingVibrationsRearAccelerating,
                                            responses: [],
                                        },
                                        {
                                            option: strings.WhenBraking,
                                            title: strings.PulsingVibrationsRearBraking,
                                            responses: [],
                                        },
                                        {
                                            option: strings.HigherSpeeds,
                                            title: strings.PulsingVibrationsRearHigh,
                                            responses: [],
                                        },
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.PulsingVibrationsRearAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.PulsingVibrationsRearNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.SteeringWheel,
                                    title: strings.PulsingVibrationsSteeringWheel,
                                    responses: [
                                        {
                                            option: strings.WhenAccelerating,
                                            title: strings.PulsingVibrationsSteeringWheelAccelerating,
                                            responses: [],
                                        },
                                        {
                                            option: strings.WhenBraking,
                                            title: strings.PulsingVibrationsSteeringWheelBraking,
                                            responses: [],
                                        },
                                        {
                                            option: strings.WhenTurning,
                                            title: strings.PulsingVibratingSteeringWheelTurning,
                                            responses: [],
                                        },
                                        {
                                            option: strings.HigherSpeeds,
                                            title: strings.PulsingVibratingSteeringWheelSpeeds,
                                            responses: [],
                                        },
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.PulsingVibratingSteeringWheelAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.PulsingVibrationsSteeringWheelNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.None,
                                    title: strings.PulsingVibrationsVehicle,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.Swaying,
                            title: strings.SwayingSideToSide,
                            responses: [],
                        },
                        {
                            option: strings.None,
                            title: strings.FeelsDifferent,
                            responses: [],
                        },
                    ],
                },
                {
                    option: strings.IHearIt,
                    underlined: strings.Hear,
                    title: strings.IHear,
                    responses: [
                        {
                            option: strings.SquealingChirping,
                            title: strings.SquealingChirpingFrom,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.SquealingChirpingEngine,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.SquealingChirpingEngineAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.WhenStopping,
                                            title: strings.SquealingChirpingEngineStopping,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenStarting,
                                            title: strings.SquealingChirpingEngineStarting,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenTurning,
                                            title: strings.SquealingChirpingEngineTurning,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhileMoving,
                                            title: strings.SquealingChirpingEngineMoving,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.SquealingChirpingEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Interior,
                                    title: strings.SquealingChirpingInterior,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.SquealingChirpingInteriorAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.HeatOrAC,
                                            title: strings.SquealingChirpingInteriorHeatAC,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.SquealingChirpingInteriorNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Under,
                                    title: strings.SquealingChirpingUnder,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.SquealingChirpingUnderAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.WhenStopping,
                                            title: strings.SquealingChirpingUnderStopping,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenTurning,
                                            title: strings.SquealingChirpingUnderTurning,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhileMoving,
                                            title: strings.SquealingChirpingUnderMoving,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.SquealingChirpingUnderNone,
                                            responses: [],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            option: strings.Hissing,
                            title: strings.HearHissing,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.HissingEngine,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.HissingEngineAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenStarting,
                                            title: strings.HissingEngineStarting,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhileMoving,
                                            title: strings.HissingEngineMoving,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.HissingEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Interior,
                                    title: strings.HissingInterior,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.HissingInteriorAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.HeatOrAC,
                                            title: strings.HissingInteriorHeatAC,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.HissingInteriorNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.FromTire,
                                    title: strings.HissingTire,
                                    responses: [
                                        {
                                            option: strings.DriversSideFront,
                                            title: strings.HissingTireDriversSideFront,
                                            responses: [],
                                        },
                                        {
                                            option: strings.DriversSideRear,
                                            title: strings.HissingTireDriversSideRear,
                                            responses: [],
                                        },
                                        {
                                            option: strings.PassengersSideFront,
                                            title: strings.HissingTirePassengersSideFront,
                                            responses: [],
                                        },
                                        {
                                            option: strings.PassengersSideRear,
                                            title: strings.HissingTirePassengersSideRear,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OtherTire,
                                            title: strings.HissingOtherTire,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.None,
                                    title: strings.HissingNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.Knocking,
                            title: strings.HearKnocking,
                            responses: [
                                {
                                    option: strings.AllTheTime,
                                    title: strings.HearKnockingAll,
                                    responses: [],
                                },
                                {
                                    option: strings.OnlyWhenStarting,
                                    title: strings.KnockingStarting,
                                    responses: [],
                                },
                                {
                                    option: strings.None,
                                    title: strings.KnockingNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.Tapping,
                            title: strings.HearTapping,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.TappingEngine,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.TappingEngineAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenStarting,
                                            title: strings.TappingEngineStarting,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhileMoving,
                                            title: strings.TappingEngineMoving,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.TappingEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Under,
                                    title: strings.TappingUnder,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.TappingUnderAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenStarting,
                                            title: strings.TappingUnderStarting,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhileMoving,
                                            title: strings.TappingUnderMoving,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.TappingUnderNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.None,
                                    title: strings.TappingNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.Rattle,
                            title: strings.HearRattle,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.RattleEngine,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.RattleEngineAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenStarting,
                                            title: strings.RattleEngineStarting,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhileMoving,
                                            title: strings.RattleEngineMoving,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.RattleEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Under,
                                    title: strings.RattleUnder,
                                    responses: [],
                                },
                                {
                                    option: strings.Interior,
                                    title: strings.RattleInterior,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.RattleInteriorAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.HeatOrAC,
                                            title: strings.RattleInteriorHeatAC,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.RattleInteriorNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.None,
                                    title: strings.RattleNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.Grinding,
                            title: strings.HearGrinding,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.GrindingEngine,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.GrindingEngineAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.WhenStopping,
                                            title: strings.GrindingEngineStopping,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenStarting,
                                            title: strings.GrindingEngineStarting,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenTurning,
                                            title: strings.GrindingEngineTurning,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.GrindingEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Under,
                                    title: strings.GrindingUnder,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.GrindingUnderAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.WhenStopping,
                                            title: strings.GrindingUnderStopping,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenTurning,
                                            title: strings.GrindingUnderTurning,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.GrindingUnderNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.None,
                                    title: strings.GrindingNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.Clunk,
                            title: strings.HearClunk,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.ClunkEngine,
                                    responses: [
                                        {
                                            option: strings.OnlyWhenTurning,
                                            title: strings.ClunkEngineTurning,
                                            responses: [],
                                        },
                                        {
                                            option: strings.Bumps,
                                            title: strings.ClunkEngineBumps,
                                            responses: [],
                                        },
                                        {
                                            option: strings.Gear,
                                            title: strings.ClunkEngineGear,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.ClunkEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Under,
                                    title: strings.ClunkUnder,
                                    responses: [
                                        {
                                            option: strings.OnlyWhenTurning,
                                            title: strings.ClunkUnderTurning,
                                            responses: [],
                                        },
                                        {
                                            option: strings.Bumps,
                                            title: strings.ClunkUnderBumps,
                                            responses: [],
                                        },
                                        {
                                            option: strings.Gear,
                                            title: strings.ClunkUnderGear,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.ClunkUnderNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.None,
                                    title: strings.ClunkNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.None,
                            title: strings.SoundNone,
                            responses: [],
                        },
                    ],
                },
                {
                    option: strings.ISeeIt,
                    underlined: strings.See,
                    title: strings.ISee,
                    responses: [
                        {
                            option: strings.Smoke,
                            title: strings.SeeSmoke,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.SeeSmokeEngine,
                                    responses: [
                                        {
                                            option: strings.AppearsBlack,
                                            title: strings.BlackSmokeEngine,
                                            responses: [],
                                        },
                                        {
                                            option: strings.AppearsBlue,
                                            title: strings.BlueSmokeEngine,
                                            responses: [],
                                        },
                                        {
                                            option: strings.AppearsWhite,
                                            title: strings.WhiteSmokeEngine,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.SmokeEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.ExhaustPipe,
                                    title: strings.SmokeExhaust,
                                    responses: [
                                        {
                                            option: strings.AppearsBlack,
                                            title: strings.SmokeExhaustBlack,
                                            responses: [],
                                        },
                                        {
                                            option: strings.AppearsBlue,
                                            title: strings.SmokeExhaustBlue,
                                            responses: [],
                                        },
                                        {
                                            option: strings.AppearsWhite,
                                            title: strings.SmokeExhaustWhite,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.SmokeExhaustNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Interior,
                                    title: strings.SmokeInterior,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.PuddleLeak,
                            title: strings.SeePuddleLeak,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.PuddleLeakEngine,
                                    responses: [
                                        {
                                            option: strings.EngineOil,
                                            title: strings.PuddleLeakEngineOil,
                                            responses: [],
                                        },
                                        {
                                            option: strings.TransmissionFluid,
                                            title: strings.PuddleLeakEngineTransmissionFluid,
                                            responses: [],
                                        },
                                        {
                                            option: strings.PowerSteeringFluid,
                                            title: strings.PuddleLeakEnginePowerSteeringFluid,
                                            responses: [],
                                        },
                                        {
                                            option: strings.Coolant,
                                            title: strings.PuddleLeakEngineCoolant,
                                            responses: [],
                                        },
                                        {
                                            option: strings.Gasoline,
                                            title: strings.PuddleLeakEngineGasoline,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.PuddleLeakEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Under,
                                    title: strings.PuddleLeakUnder,
                                    responses: [
                                        {
                                            option: strings.EngineOil,
                                            title: strings.PuddleLeakUnderEngineOil,
                                            responses: [],
                                        },
                                        {
                                            option: strings.TransmissionFluid,
                                            title: strings.PuddleLeakUnderTransmissionFluid,
                                            responses: [],
                                        },
                                        {
                                            option: strings.PowerSteeringFluid,
                                            title: strings.PuddleLeakUnderPowerSteeringFluid,
                                            responses: [],
                                        },
                                        {
                                            option: strings.Coolant,
                                            title: strings.PuddleLeakUnderCoolant,
                                            responses: [],
                                        },
                                        {
                                            option: strings.Gasoline,
                                            title: strings.PuddleLeakUnderGasoline,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.PuddleLeakUnderNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Interior,
                                    title: strings.PuddleLeakInterior,
                                    responses: [
                                        {
                                            option: strings.Water,
                                            title: strings.PuddleLeakInteriorWater,
                                            responses: [],
                                        },
                                        {
                                            option: strings.Refrigerant,
                                            title: strings.PuddleLeakInteriorRefrigerant,
                                            responses: [],
                                        },
                                        {
                                            option: strings.CoolantSmell,
                                            title: strings.PuddleLeakInteriorCoolant,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.PuddleLeakInteriorNone,
                                            responses: [],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            option: strings.LowFlatTire,
                            title: strings.SeeLowFlatTire,
                            responses: [
                                {
                                    option: strings.OnDriversSideFront,
                                    title: strings.LowFlatTireDriversSideFront,
                                    responses: [],
                                },
                                {
                                    option: strings.OnDriversSideRear,
                                    title: strings.LowFlatTireDriversSideRear,
                                    responses: [],
                                },
                                {
                                    option: strings.OnPassengersSideFront,
                                    title: strings.LowFlatTirePassengersSideFront,
                                    responses: [],
                                },
                                {
                                    option: strings.OnPassengersSideRear,
                                    title: strings.LowFlatTirePassengersSideRear,
                                    responses: [],
                                },
                                {
                                    option: strings.OtherTire,
                                    title: strings.LowFlatTireNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.WarningLight,
                            title: strings.ISeeThe,
                            responses: [
                                {
                                    option: strings.CheckEngineLight,
                                    title: strings.SeeCheckEngineLight,
                                    responses: [
                                        {
                                            option: strings.OccasionallyOn,
                                            title: strings.CheckEngineLightOccasionally,
                                            responses: [],
                                        },
                                        {
                                            option: strings.ConstantlyOn,
                                            title: strings.CheckEngineLightConstantly,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.TirePressureWarning,
                                    title: strings.SeeTirePressureWarning,
                                    responses: [
                                        {
                                            option: strings.OccasionallyOn,
                                            title: strings.TirePressureWarningOccasionally,
                                            responses: [],
                                        },
                                        {
                                            option: strings.ConstantlyOn,
                                            title: strings.TirePressureWarningConstantly,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.CoolantTemperatureWarning,
                                    title: strings.SeeCoolantTemperatureWarning,
                                    responses: [
                                        {
                                            option: strings.OccasionallyOn,
                                            title: strings.CoolantTemperatureWarningOccasionally,
                                            responses: [],
                                        },
                                        {
                                            option: strings.ConstantlyOn,
                                            title: strings.CoolantTemperatureWarningConstantly,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.BatteryChargeWarning,
                                    title: strings.SeeBatteryChargeWarning,
                                    responses: [
                                        {
                                            option: strings.OccasionallyOn,
                                            title: strings.BatteryChargeWarningOccasionally,
                                            responses: [],
                                        },
                                        {
                                            option: strings.ConstantlyOn,
                                            title: strings.BatteryChargeWarningConstantly,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.OilPressureWarning,
                                    title: strings.SeeOilPressureWarning,
                                    responses: [
                                        {
                                            option: strings.OccasionallyOn,
                                            title: strings.OilPressureWarningOccasionally,
                                            responses: [],
                                        },
                                        {
                                            option: strings.ConstantlyOn,
                                            title: strings.OilPressureWarningConstantly,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.BrakeABSWarning,
                                    title: strings.SeeBrakeABSWarning,
                                    responses: [
                                        {
                                            option: strings.OccasionallyOn,
                                            title: strings.BrakeABSWarningOccasionally,
                                            responses: [],
                                        },
                                        {
                                            option: strings.ConstantlyOn,
                                            title: strings.BrakeABSWarningConstantly,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.StabilityTractionWarning,
                                    title: strings.SeeStabilityTractionWarning,
                                    responses: [
                                        {
                                            option: strings.OccasionallyOn,
                                            title: strings.StabilityTractionWarningOccasionally,
                                            responses: [],
                                        },
                                        {
                                            option: strings.ConstantlyOn,
                                            title: strings.StabilityTractionWarningConstantly,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.OtherWarningLight,
                                    title: strings.WarningLightOther,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.None,
                            title: strings.SomethingLooksDifferent,
                            responses: [],
                        },
                    ],
                },
                {
                    option: strings.ISmellIt,
                    underlined: strings.Smell,
                    title: strings.ISmell,
                    responses: [
                        {
                            option: strings.Gasoline,
                            title: strings.SmellGasoline,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.SmellGasolineEngine,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.SmellGasolineEngineAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.EngineRunning,
                                            title: strings.SmellGasolineEngineRunning,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.SmellGasolineEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Under,
                                    title: strings.SmellGasolineUnder,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.SmellGasolineUnderAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.EngineRunning,
                                            title: strings.SmellGasolineUnderRunning,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.SmellGasolineUnderNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.None,
                                    title: strings.SmellGasolineNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.RottenEggsSulfur,
                            title: strings.SmellRottenEggsSulfur,
                            responses: [],
                        },
                        {
                            option: strings.Mildew,
                            title: strings.SmellMildew,
                            responses: [
                                {
                                    option: strings.AllTheTime,
                                    title: strings.SmellMildewAll,
                                    responses: [],
                                },
                                {
                                    option: strings.HeatOrAC,
                                    title: strings.SmellMildewHeatAC,
                                    responses: [],
                                },
                                {
                                    option: strings.None,
                                    title: strings.SmellMildewNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.Antifreeze,
                            title: strings.SmellAntrifreeze,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.SmellAntiFreezeEngine,
                                    responses: [],
                                },
                                {
                                    option: strings.Interior,
                                    title: strings.SmellAntiFreezeInterior,
                                    responses: [
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.SmellAntiFreezeInteriorAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.OnlyWhenHeat,
                                            title: strings.SmellAntiFreezeInteriorHeat,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.SmellAntifreezeNone,
                                            responses: [],
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            option: strings.BurningOil,
                            title: strings.SmellBurningOil,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.SmellBurningOilEngine,
                                    responses: [],
                                },
                                {
                                    option: strings.ExhaustPipe,
                                    title: strings.SmellBurningOilExhaust,
                                    responses: [],
                                },
                                {
                                    option: strings.None,
                                    title: strings.SmellBurningOilNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.ExhaustGas,
                            title: strings.SmellExhaustGas,
                            responses: [
                                {
                                    option: strings.TheEngine,
                                    title: strings.SmellExhaustGasEngine,
                                    responses: [
                                        {
                                            option: strings.OnlyDuringStartup,
                                            title: strings.SmellExhaustGasEngineStartup,
                                            responses: [],
                                        },
                                        {
                                            option: strings.AllTheTime,
                                            title: strings.SmellExhaustGasEngineAll,
                                            responses: [],
                                        },
                                        {
                                            option: strings.None,
                                            title: strings.SmellExhaustGasEngineNone,
                                            responses: [],
                                        },
                                    ],
                                },
                                {
                                    option: strings.Interior,
                                    title: strings.SmellExhaustGasInterior,
                                    responses: [],
                                },
                                {
                                    option: strings.None,
                                    title: strings.SmellExhaustGasNone,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.None,
                            title: strings.SmellNone,
                            responses: [],
                        },
                    ],
                },
                {
                    option: strings.VehicleNotFunction,
                    underlined: strings.NotFunction,
                    title: strings.MyVehicles,
                    responses: [
                        {
                            option: strings.EngineWontStart,
                            title: strings.MyVehiclesEngine,
                            responses: [
                                {
                                    option: strings.StartsStalls,
                                    title: strings.EngineStartsStalls,
                                    responses: [],
                                },
                                {
                                    option: strings.CranksWontRun,
                                    title: strings.EngineCranksWontRun,
                                    responses: [],
                                },
                                {
                                    option: strings.DoesntCrank,
                                    title: strings.EngineDoesntCrank,
                                    responses: [],
                                },
                                {
                                    option: strings.None,
                                    title: strings.VehiclesEngineWontStart,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.VentsWontBlowHot,
                            title: strings.MyVehiclesVents,
                            responses: [
                                {
                                    option: strings.OnlyColdAir,
                                    title: strings.VehicleOnlyColdAir,
                                    responses: [],
                                },
                                {
                                    option: strings.WontBlowAir,
                                    title: strings.NoAir,
                                    responses: [],
                                },
                                {
                                    option: strings.None,
                                    title: strings.WontBlowHot,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.VentsWontBlowCold,
                            title: strings.MyVehiclesVents,
                            responses: [
                                {
                                    option: strings.OnlyWarmAir,
                                    title: strings.VehicleOnlyWarmAir,
                                    responses: [],
                                },
                                {
                                    option: strings.WontBlowAir,
                                    title: strings.NoAir,
                                    responses: [],
                                },
                                {
                                    option: strings.None,
                                    title: strings.WontBlowCold,
                                    responses: [],
                                },
                            ],
                        },
                        {
                            option: strings.EngineRunsVehicleWontMove,
                            title: strings.VehiclesEngineRunsVehicleWontMove,
                            responses: [],
                        },
                        {
                            option: strings.None,
                            title: strings.MyVehicle,
                            responses: [],
                        },
                    ],
                },
                {
                    option: strings.OtherNone,
                    title: strings.DescribeVehiclesIssue,
                    responses: [],
                },
            ],
        },
    ];
    const noArrow = props.theme === 'porsche' || props.theme === 'bmw' ? true : false;

    useEffect(() => {
        if (dialogActive) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'service',
                errorCode: '',
                itemResults: '',
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
        }
    }, [dialogActive, props.vehicles, props.selectedVehicle]);

    const interactionHandler = useCallback((e: any, text: string, color: 'bgColor' | 'color') => {
        let elementColor = '';
        if (color === 'color') {
            elementColor = getElementColor(e, 'color');
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: text,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'popup',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props.selectedVehicle, props.vehicles]);

    const diagnoseHandler = useCallback((e: any) => {
        setDialogActive(true);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.DiagnoseButton,
            elementColor: '',
            elementOrder: '',
            elementType: 'popup',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'open',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props.vehicles, props.selectedVehicle]);

    const onChangeHandler = useCallback((value: string) => {
        setAdditionalComments(value);
        commentRef.current = value;
        const notOther = document.querySelector('#h4LightBox')?.textContent;
        if (notOther !== strings.DescribeVehiclesIssue) {
            setError(false);
        } else if ((/\S/.test(additionalComments) && additionalComments.length > 1 && /\S/.test(value)) || /\S/.test(value)) {
            setError(false);
        } else {
            setError(true);
        }
    }, [additionalComments]);

    const selectButtonHandler = (value: string) => {
        props.selectButton(value);
        if (responses[value]?.option === strings.OtherNone) {
            setError(true);
        } else {
            setError(false);
        }
        setSelectedButton('');
    };

    // Set the selected button to the previously selected option
    const backHandler = useCallback((e: any) => {
        const prevButton = props.indexMap[props.indexMap.length - 1];
        setAdditionalComments('');
        if (prevButton) {
            setSelectedButton(prevButton.index);
        }
        props.backButton();
        if (diagnoseModalViews.current.length > 1) {
            diagnoseModalViews.current.pop();
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.BackButton,
            elementColor: '',
            elementOrder: '',
            elementType: 'popup',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'back',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props.backButton, props.indexMap, diagnoseModalViews, props.selectedVehicle, props.vehicles]);

    const nextHandler = useCallback((e: any) => {
        props.nextButton(selectedButton);
        setSelectedButton('');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: strings.NextButton,
            elementColor: '',
            elementOrder: '',
            elementType: 'popup',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props.nextButton, selectedButton, props.vehicles, props.selectedVehicle]);

    const cancelHandler = useCallback(() => {
        setDialogActive(false);
        props.clearIndexMap();
        setSelectedButton('');
        setAdditionalComments('');
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: commentRef.current,
            elementType: 'popup',
            elementColor: '',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, '');
        commentRef.current = '';
        diagnoseModalViews.current = [];
    }, [props.clearIndexMap]);

    const addHandler = useCallback((title: string) => {
        diagnoseModalViews.current = [];
        setDialogActive(false);
        props.addDiagnosis(title, commentRef.current);
        setSelectedButton('');
        setAdditionalComments('');
        commentRef.current = '';
    }, [props.addDiagnosis]);

    let responses: diagnoseResponses[] = diagnoseLiterals[0].responses;
    let title = diagnoseLiterals[0].title;

    props.indexMap.forEach((i) => {
        title = responses[i.index].title;
        responses = responses[i.index].responses;
    });

    let otherResponse = false;
    let endDialogTree = false;
    // If no responses exist, then we are at the end of the dialog tree.
    if (responses.length === 0) {
        endDialogTree = true;
        // If "Other" is selected
        if (title === strings.DescribeVehiclesIssue) {
            otherResponse = true;
        }
    }
    const paper = classNames(
        css.paper,
        {
            [css.paperLexus]: props.theme === 'lexus',
        },
    );

    return (
        <div className={css.diagnose}>
            <h4 id='h2'>{strings.Diagnose}</h4>
            <h5 id='h3'>{props.title ? props.title : strings.WalkThroughIssue}</h5>
            <div>
                <SVPButton
                    id='diagnoseBtn'
                    message={strings.DiagnoseButton}
                    variant='secondaryBtn'
                    noArrow={noArrow}
                    handler={(e: any) => diagnoseHandler(e)}
                    tooltip={strings.SelfDiagnoseTip}
                    theme={props.theme}
                />
            </div>
            <Dialog
                cssClasses={{
                    content: css.content,
                    // contextHeader: css.header,
                    paper: paper,
                    header: css.LightBoxHeader,
                }}
                header={strings.DiagnoseHeader}
                isOpen={dialogActive}
                hideSave
                hideCancel
                onBackDropClick={(e: any) => {
                    cancelHandler();
                    interactionHandler(e, '', 'bgColor');
                }}
                onCancel={(e: any) => {
                    cancelHandler();
                    if (e?.charCode === 0) {
                        interactionHandler(e, '', 'bgColor');
                    }
                }}
                noBottomPadding
                width={'full'}
            >
                <div className={css.headerbox}>
                    {strings.DiagnoseHeader}
                    <div className={css.headerIcon}>
                        <IconRemove id='closeBtn' onClick={(e: any) => {
                            cancelHandler();
                            interactionHandler(e, '', 'color');
                        }}/>
                    </div>
                </div>
                <DesktopDiagnoseModal
                    endDialogTree={endDialogTree}
                    otherResponse={otherResponse}
                    title={title}
                    responses={responses}
                    additionalComments={additionalComments}
                    commentRef={commentRef}
                    indexMapLength={props.indexMap.length}
                    selectedButton={selectedButton}
                    vehicles={props.vehicles}
                    selectedVehicle={props.selectedVehicle}
                    selectButtonHandler={selectButtonHandler}
                    onChangeHandler={onChangeHandler}
                    addHandler={addHandler}
                    cancelHandler={(e: any) => {
                        cancelHandler();
                        interactionHandler(e, strings.Cancel, 'bgColor');
                    }}
                    backHandler={backHandler}
                    nextHandler={nextHandler}
                    error={error}
                    setError={setError}
                    diagnoseModalViews={diagnoseModalViews.current}
                    theme={props.theme}
                />
            </Dialog>
        </div>
    );
};

export default Diagnose;